define('core/components',[
	'components/ax-grid-sticky',
	'components/ReportsMenu/ReportsMenuComponent',
	'components/ProviderFilter/ProviderFilterComponent',
	'components/VendorFilter/VendorFilterComponent',
	'components/PatientFilter/PatientFilterComponent',
	'components/Search/SearchComponent',
	'components/Bootstrap/ax-tooltip',
	'components/ax-radio',
	'components/can-datepicker',
	'components/textarea-grow',
	'components/can-toggle',
	'components/RadialProgress/RadialProgressComponent',
	'pages/reports/TimelyFiling/PaginationNavComponent'
], function() {
	return true;
});
